module.exports = __webpack_public_path__ + "img/face-swear.22d53dc2.svg";